@if (type === 'duotone') {
<span class="ki-{{ type }} ki-{{ name }}{{ class ? ' ' + class : '' }}">
  @for (i of [].constructor(pathsNumber); track $index; let idx = $index) {
  <span class="path{{ idx + 1 }}"></span>
  }
</span>
} @if (type !== 'duotone') {
<span class="ki-{{ type }} ki-{{ name }}{{ class ? ' ' + class : '' }}"></span>
}

<ng-content #inside_content></ng-content>
